import './category-dropdown.common';
import stickyElement from './features/sticky-element';

// Sticky category dropdown
stickyElement('.js-wio__controls');
